import { createSlice } from "@reduxjs/toolkit"
import { login, logout, refresh, register } from "./operations";

const INITIAL_STATE = {
  user: {
    name: null,
    email: null,
  },
  token: null,
  isLoggedIn: false,
  isRefreshing: false,
};

export const authSlice = createSlice({
    name: "auth",
    initialState: INITIAL_STATE,

    extraReducers: (builder) => builder
        .addCase(register.pending, (state) => {
            state.error = null;
        })
        .addCase(register.fulfilled, (state, action) => {
            state.isLoggedIn = true;
            state.token = action.payload.token;
            state.user = action.payload.user;
        })
        .addCase(register.rejected, (state, action) => {
            state.error = action.payload;
        })

        .addCase(login.pending, (state) => {
            state.error = null;
        })
        .addCase(login.fulfilled, (state, action) => {
            state.user = action.payload.user;
            state.token = action.payload.token;
            state.isLoggedIn = true;
        })
        .addCase(login.rejected, (state, action) => {
            state.error = action.payload;
        })

        .addCase(logout.pending, (state) => {
            state.error = null;
        })
        .addCase(logout.fulfilled, (state) => {
            state.user = { name: null, email: null };
            state.token = null;
            state.isLoggedIn = false;
        })
        .addCase(logout.rejected, (state, action) => {
            state.error = action.payload;
        })

        .addCase(refresh.pending, (state) => {
            state.isRefreshing = true;
        })
        .addCase(refresh.fulfilled, (state, action) => {
            state.user = action.payload;
            state.isLoggedIn = true;
            state.isRefreshing = false;
        })
        .addCase(refresh.rejected, (state) => {
            state.isRefreshing = false;
        })
});

export const authReducer = authSlice.reducer;